import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
	ListItem,
	ListItemText,
	ListItemIcon,
	CircularProgress,
	Tooltip,
	Box,
	Typography,
	ButtonGroup,
	Button,
} from '@mui/material';
import { Check, Block, NoteAdd, DriveFileRenameOutlineRounded, InsertDriveFileRounded } from '@mui/icons-material';
import { getErrorMessage } from '../../../utils';
import { Dispatch } from 'redux';
import { ReduxComponentInterface } from 'edocatbase/Global';
import { toggleModal } from '../../../../ModalTest/actions';

interface UploadRowProps extends ReduxComponentInterface {
	item: any;
	index: number;
	onUpload: Function;
	uploading: boolean;
	count: number;
}

interface UploadRowState {
	anchor: any;
}

class UploadRow extends window.React.PureComponent<UploadRowProps, UploadRowState> {
	constructor(props: UploadRowProps) {
		super(props);
		this.state = {
			anchor: null,
		};
	}

	onMenuOpen = (event: React.ChangeEvent) => {
		this.setState({
			anchor: event.currentTarget,
		});
	};

	onMenuClose = () => {
		this.setState({
			anchor: null,
		});
	};

	onRenameAndUploadBtnClick = () => {
		const { onUpload, index } = this.props;
		onUpload(false, [index], null);
		this.onMenuClose();
	};

	onNewVersionBtnClick = () => {
		const {
			actions,
			item: { file, error },
			onUpload,
			index,
		} = this.props;
		const workingCopyNodeRef = error
			.split(',')
			.find(it => it.includes('workingcopylink'))
			?.split('_')[1];
		const [nodeRef, name, version] = error.split(',').slice(1);
		const workingCopyName = workingCopyNodeRef
			? `${name.slice(0, name.lastIndexOf('.'))} (${
					window.Alfresco.messages.global['edocat.document-actions.workingCopy']
				})${name.slice(name.lastIndexOf('.'))}`
			: '';
		actions.toggleModal(true, 'newVersionModal', {
			newFile: file,
			originalFile: {
				nodeRef: workingCopyNodeRef || nodeRef,
				name: workingCopyName || name,
				version,
			},
			onUpload,
			index: index,
			hideInput: true,
		});
		this.onMenuClose();
	};

	render() {
		const {
			item: { file, done, excluded, error, progress },
			uploading,
			count,
		} = this.props;

		return (
			<>
				<ListItem className="fileList">
					<ListItemIcon className="fileList-Icon">
						{done && (
							<Tooltip title={window.Alfresco.messages.global['edocat.upload.success']}>
								<Check color="success" />
							</Tooltip>
						)}
						{error && (
							<Tooltip title={getErrorMessage(error)}>
								<span>
									<InsertDriveFileRounded />
									<span>{count}</span>
								</span>
							</Tooltip>
						)}
						{excluded && (
							<Tooltip title={window.Alfresco.messages.global['edocat.docDetail.disallowed-extensions.text']}>
								<Block sx={{ color: '#f44336' }} />
							</Tooltip>
						)}
						{progress === -1 && !(done || error || excluded) && <CircularProgress size={30} />}
						{progress !== -1 && !(done || error || excluded) && (
							<Box position="relative" display="inline-flex">
								<CircularProgress size={30} value={progress} variant="determinate" />
								<Box
									top={0}
									left={0}
									bottom={0}
									right={0}
									position="absolute"
									display="flex"
									alignItems="center"
									justifyContent="center"
								>
									<Typography component="div" color="textSecondary" sx={{ fontSize: '0.6rem !important' }}>
										{`${progress}%`}
									</Typography>
								</Box>
							</Box>
						)}
					</ListItemIcon>
					<ListItemText primary={file.name} />
					{error && error.includes('file exists') && (
						<ButtonGroup
							className="fileActions"
							size="small"
							variant="text"
							disableElevation
							disableFocusRipple
							disableRipple
						>
							<Tooltip title={window.Alfresco.messages.global['edocat.upload.rename']}>
								<Button onClick={this.onRenameAndUploadBtnClick} disabled={uploading}>
									<DriveFileRenameOutlineRounded />
								</Button>
							</Tooltip>
							<Tooltip title={window.Alfresco.messages.global['edocat.upload.button.new-version']}>
								<Button onClick={this.onNewVersionBtnClick} disabled={uploading}>
									<NoteAdd />
								</Button>
							</Tooltip>
						</ButtonGroup>
					)}
				</ListItem>
			</>
		);
	}
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
	actions: bindActionCreators({ toggleModal }, dispatch),
});

export default connect(null, mapDispatchToProps)(UploadRow);
